/* Optional enhancement; country and language changes remain native Shopify forms. */
(function () {
  'use strict';
  if (window.JBRecordedLocale || !('showPopover' in HTMLElement.prototype) || !CSS.supports('selector(:popover-open)')) return;
  window.JBRecordedLocale = true;
  const mobile = window.matchMedia('(max-width:767px)');
  const hover = window.matchMedia('(hover:hover) and (pointer:fine)');
  const openers = new WeakMap();
  const owners = new WeakMap();
  const ready = new WeakSet();
  const roots = new Set();
  const visible = element => !!(element.getClientRects().length) && !element.closest('[inert]');
  function isOpen(element) { return element.matches(':popover-open'); }
  function setup(scope) {
    scope.querySelectorAll('.jb-locale-modal').forEach(dialog => {
      if (ready.has(dialog)) return;
      ready.add(dialog);
      const owner = dialog.closest('.shopify-section');
      if (owner) owners.set(dialog, owner);
      // A top-layer popover must not inherit the mobile menu's inert/transform state.
      document.body.appendChild(dialog);
      roots.add(dialog);
      dialog.setAttribute('data-jb-locale-enhanced', '');
      dialog.querySelectorAll('.jb-locale-modal__region-label').forEach(label => {
        label.addEventListener('pointerenter', () => {
          if (mobile.matches || !hover.matches) return;
          const radio = document.getElementById(label.htmlFor);
          if (radio) radio.checked = true;
        });
      });
      dialog.querySelectorAll('.jb-locale-modal__accordion').forEach(details => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          dialog.querySelectorAll('.jb-locale-modal__accordion').forEach(other => {
            if (other !== details) other.open = false;
          });
        });
      });
      dialog.addEventListener('beforetoggle', event => {
        if (event.newState !== 'open') return;
        const source = event.source || document.activeElement;
        if (source && source !== document.body && !dialog.contains(source)) openers.set(dialog, source);
        const scroll = dialog.querySelector('.jb-locale-modal__scroll');
        if (scroll) scroll.scrollTop = 0;
      });
      dialog.addEventListener('toggle', event => {
        if (event.newState === 'open') {
          dialog.setAttribute('aria-modal', 'true');
          requestAnimationFrame(() => {
            if (!isOpen(dialog)) return;
            const scroll = dialog.querySelector('.jb-locale-modal__scroll');
            if (scroll) scroll.scrollTop = 0;
            dialog.querySelector('.jb-locale-modal__close')?.focus({preventScroll:true});
          });
        } else {
          dialog.removeAttribute('aria-modal');
          const opener = openers.get(dialog);
          if (opener?.isConnected && visible(opener)) opener.focus({preventScroll:true});
        }
      });
    });
  }
  window.addEventListener('keydown', event => {
    const dialog = Array.from(roots).find(isOpen);
    if (!dialog) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      dialog.hidePopover();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),summary,[tabindex="0"]'))
      .filter(element => visible(element) && (element.type !== 'radio' || element.checked));
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  }, true);
  function reset() { roots.forEach(dialog => { if (isOpen(dialog)) dialog.hidePopover(); }); }
  window.addEventListener('pagehide', reset);
  window.addEventListener('pageshow', event => { if (event.persisted) reset(); });
  mobile.addEventListener('change', () => roots.forEach(dialog => {
    const scroll = dialog.querySelector('.jb-locale-modal__scroll');
    if (scroll && isOpen(dialog)) scroll.scrollTop = 0;
  }));
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => roots.forEach(dialog => {
    if (owners.get(dialog) !== event.target) return;
    if (isOpen(dialog)) dialog.hidePopover();
    dialog.remove(); roots.delete(dialog);
  }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document), {once:true});
  else setup(document);
})();
